var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFamilyStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.797,
    height: 21.294,
    viewBox: "0 0 19.797 21.294",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12665",
    "data-name": "Group 12665",
    transform: "translate(444.246 -154.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4734",
    "data-name": "Path 4734",
    d: "M-395.954,239.746a1.984,1.984,0,0,0-1.316-3.125,4.651,4.651,0,0,1,.124-.563,2.86,2.86,0,0,1,2.633-2.084c1.206-.079,2.424.006,3.636.027a1.517,1.517,0,0,1,.4.087c.395.119.717.257.7.8a2.1,2.1,0,0,0,.675,1.423c-.167.047-.314.079-.455.13a2.922,2.922,0,0,0-2.119,2.648c-.085,1.334-.046,2.678-.009,4.017a2.035,2.035,0,0,0,.994,1.643.428.428,0,0,1,.211.413c-.007,1.034,0,2.069,0,3.1a1.835,1.835,0,0,1-1.964,1.954,6.968,6.968,0,0,1-1.321-.065,1.759,1.759,0,0,1-1.39-1.733c-.007-.6-.01-1.2.006-1.8a.469.469,0,0,1,.166-.324,1.8,1.8,0,0,0,.809-1.405,27.025,27.025,0,0,0-.006-2.943,2.358,2.358,0,0,0-1.642-2.125A1.189,1.189,0,0,1-395.954,239.746Z",
    transform: "translate(-44 -74.041)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4735",
    "data-name": "Path 4735",
    d: "M-297.636,288.592c-.215-.046-.4-.07-.581-.127a1.633,1.633,0,0,1-1.147-1.607c-.011-1.119-.014-2.238,0-3.356a2.362,2.362,0,0,1,2.2-2.49,20.916,20.916,0,0,1,3.094.028,3.728,3.728,0,0,1,1.017.372,2.1,2.1,0,0,0,.007,2.371,6.559,6.559,0,0,0-.688.365,2.457,2.457,0,0,0-1.1,2.093c-.013.8-.005,1.6,0,2.406a1.959,1.959,0,0,0,.863,1.7.429.429,0,0,1,.153.3c.013.707.016,1.414,0,2.121a1.457,1.457,0,0,1-1.509,1.49q-.38,0-.76,0a1.492,1.492,0,0,1-1.538-1.538c-.007-1.267,0-2.533,0-3.8Z",
    transform: "translate(-135.695 -118.085)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4736",
    "data-name": "Path 4736",
    d: "M-440.114,340.416c0,1.026,0,2.059,0,3.092a1.024,1.024,0,0,1-.815,1.065,3.483,3.483,0,0,1-1.218-.006,1.04,1.04,0,0,1-.809-1.1c-.006-.9,0-1.794,0-2.691,0-.115,0-.231,0-.362-.142-.032-.273-.055-.4-.092a1.189,1.189,0,0,1-.875-1.115c-.012-.929-.02-1.858.005-2.786a1.78,1.78,0,0,1,1.711-1.671c.654-.014,1.309-.013,1.963,0a1.745,1.745,0,0,1,1.7,1.567c.056.967.052,1.941.018,2.91C-438.856,339.889-439.251,340.218-440.114,340.416Z",
    transform: "translate(0 -168.449)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4737",
    "data-name": "Path 4737",
    d: "M-213.546,340.44c0,.973-.026,1.933.008,2.891a1.191,1.191,0,0,1-1.336,1.338c-.136-.012-.274,0-.411,0a1.094,1.094,0,0,1-1.1-1.106c-.006-1.033,0-2.066,0-3.078a4.368,4.368,0,0,1-.721-.273,1.177,1.177,0,0,1-.581-1.061c-.006-.855-.026-1.711.007-2.564a1.8,1.8,0,0,1,1.912-1.8c.57,0,1.14-.006,1.71,0a1.79,1.79,0,0,1,1.793,1.756c.018.844.01,1.688.006,2.533a1.238,1.238,0,0,1-1.115,1.341C-213.427,340.422-213.477,340.429-213.546,340.44Z",
    transform: "translate(-212.191 -168.489)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4738",
    "data-name": "Path 4738",
    d: "M-358.834,154.892a2.157,2.157,0,0,1,2.151,2.152,2.178,2.178,0,0,1-2.138,2.142,2.164,2.164,0,0,1-2.159-2.147A2.138,2.138,0,0,1-358.834,154.892Z",
    transform: "translate(-77.991)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4739",
    "data-name": "Path 4739",
    d: "M-269.278,218.251a1.726,1.726,0,0,1,1.738-1.746,1.749,1.749,0,0,1,1.761,1.733,1.77,1.77,0,0,1-1.764,1.772A1.754,1.754,0,0,1-269.278,218.251Z",
    transform: "translate(-163.884 -57.711)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4740",
    "data-name": "Path 4740",
    d: "M-195.072,287.916a1.271,1.271,0,0,1,1.3-1.289,1.287,1.287,0,0,1,1.3,1.3,1.323,1.323,0,0,1-1.311,1.3A1.311,1.311,0,0,1-195.072,287.916Z",
    transform: "translate(-233.388 -123.389)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4741",
    "data-name": "Path 4741",
    d: "M-419.38,287.93a1.312,1.312,0,0,1-1.308,1.3,1.323,1.323,0,0,1-1.292-1.322,1.287,1.287,0,0,1,1.314-1.285A1.273,1.273,0,0,1-419.38,287.93Z",
    transform: "translate(-20.855 -123.386)",
    fill: "#febaba"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyStatus);
export default __webpack_public_path__ + "static/media/familyStatus.222a07ef779379d3795743c1ca4ed07f.svg";
export { ForwardRef as ReactComponent };